export default __webpack_public_path__ + "icon613be17.svg";